import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-burger',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" [attr.width]="size()"
         [attr.height]="size()">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
            d="M4 6h16M4 12h16M4 18h16"></path>
    </svg>
  `
})
export class IconBurgerComponent {
  size: InputSignal<number> = input<number>(24);
}
